import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconSetupService {
  constructor(
    private registry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  init(): void {
    const icons = [
      'progress_activity',
      'close',
      'add',
      'clock_loader',
      'compare_arrows',
      'clock_loader_20',
      'delete',
      'globe',
      'logout',
      'stacks',
      'view_cozy',
      'search',
      'language',
      'note_stack',
      'menu_book',
      'help',
      'cloud_upload',
      'person',
      'upload_file',
      'quick_reference',
      'download',
      'outgoing_mail',
      'edit_square',
      'check',
      'quick_reference_all',
      'info',
      'workspaces',
      'unlink',
      'arrow_back',
      'chevron_left',
      'data_alert',
      'right_panel_open',
      'link',
      'link_off',
      'warning',
      'text_compare',
      'signature',
      'closed_caption',
      'tune',
      'block',
      'reorder',
      'check_circle',
    ];

    icons.forEach((name) => {
      this.registry.addSvgIcon(
        name,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`),
      );
    });
  }
}
